import { createAsyncThunk } from "@reduxjs/toolkit";
import { toggleAdminPagePublished } from "@/lib/api-server/admin/page/toggleAdminPagePublished";
import { IAdminSlice } from "@/redux/slices/admin/types";

export const putPagePublic = createAsyncThunk(
  "admin/putPagePublic",
  async (
    {
      public: isPublic,
      uuid,
    }: {
      public: 0 | 1;
      uuid: string;
    },
    { rejectWithValue }
  ) =>
    await toggleAdminPagePublished(uuid, isPublic === 1).then((r) => {
      if (!r.success) return rejectWithValue(r.error);
      return r.data;
    })
);

const pending = (
  state: IAdminSlice,
  { meta }: { meta: { arg: { uuid: string } } }
) => {
  state.pages = state.pages.map((p: any) => {
    if (p.uuid === meta.arg.uuid) {
      return {
        ...p,
        loading: true,
      };
    }
    return p;
  });
};

const rejected = (
  state: IAdminSlice,
  { meta }: { meta: { arg: { uuid: string } } }
) => {
  state.pages = state.pages.map((p: any) => {
    if (p.uuid === meta.arg.uuid) {
      return {
        ...p,
        loading: false,
      };
    }
    return p;
  });
};

const fulfilled = (state: IAdminSlice, { payload }: { payload: any }) => {
  state.pages = state.pages.map((p: any) => {
    if (p.uuid === payload.uuid) {
      return {
        ...p,
        is_public: payload.is_public,
        loading: false,
      };
    }
    return p;
  });
};

export default {
  action: putPagePublic,
  pending,
  rejected,
  fulfilled,
};
